export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-white py-12 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <img 
                src="/elevatex-logo.jpg" 
                alt="ElevateX Solutions" 
                className="h-10 w-10 object-contain bg-white rounded-lg p-1"
              />
              <div>
                <h3 className="text-lg font-bold">ElevateX Solutions</h3>
                <p className="text-sm text-slate-400">Elevating Careers</p>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Empowering professionals with AI-driven career tools and opportunities to reach their full potential.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="/" 
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Resume Scorer
                </a>
              </li>
              <li>
                <a 
                  href="https://elevatex.solutions/hiring" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Open Positions
                </a>
              </li>
              <li>
                <a 
                  href="https://elevatex.solutions" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  About ElevateX
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Get In Touch</h4>
            <div className="space-y-2">
              <p className="text-slate-400 text-sm">
                Ready to elevate your career?
              </p>
              <a 
                href="https://elevatex.solutions/hiring" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-[#2563EB] hover:bg-[#1e40af] text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
              >
                View Open Positions
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © 2024 ElevateX Solutions. All rights reserved.
          </p>
          <p className="text-slate-400 text-sm">
            Powered by AI • Built for Success
          </p>
        </div>
      </div>
    </footer>
  );
}